import {sendGaEvent} from "BdhCommon/js/ga";

export const sendEvent = (action, label) => {
    sendGaEvent('zorganalyse 2018', action, label);
};